export class Messages {
    public static onValidated = "on-validated";
    public static documentClick = "document-click";
    public static updateUser = "update-user";
    public static changeEntityItemStep = "change-entity-item-step";
    public static refreshChangeLog = "refresh-changelog";
    public static refreshAttachments = "refresh-attachments";
    public static attachmentsModified = "attachments-modified";
    public static attachmentsLoaded = "attachments-loaded";
    public static workflowCompleted = "workflow-completed";
    public static showDatePicker = "show-date-picker";
    public static hideDatePicker = "hide-date-picker";
    public static comboSelected = "combo-selected"
    public static multiComboSelected = "multi-combo-selected"
    public static buttonClick = "button-click";
    public static unlockFeature = "unlock-feature";
    public static cardClick = "card-click";
}